import { normalize } from 'normalizr';

export default function middlewareNormalizeDataGenerator(schema: Object) {
  return () => next => action => {
    const actionData = action.data;

    if (!actionData || Object.keys(actionData).length === 0 || action.bypassMiddleware) {
      return next(action);
    }

    const normalizedData = normalize(actionData, schema);
    action.data = normalizedData.entities;
    action.normalizeResults = normalizedData.result;

    return next(action);
  };
}





// WEBPACK FOOTER //
// ./~/virgo/src/middlewares/middlewareNormalizeDataGenerator.js